import { IteratorField } from '@epages/react-components'
import { useRef } from 'react'
import Immutable from 'immutable'
import cc from 'classcat'

import { Popover } from '../Popover'
import { useTranslate } from '../../utils/translate'
import CheckboxField from '../formComponents/CheckboxField'
import FormGroup from '../formComponents/FormGroup'
import FormValue from '../formComponents/FormValue'
import IconPicker from '../formComponents/IconPicker/IconPicker'
import InputField from '../formComponents/InputField'
import LinkTooltipSettingsLayer from '../templateComponents/Workspace/plugins/components/LinkTooltip/LinkTooltipSettingsLayer'

export default function HeaderUsps() {
  const textFields = useRef<HTMLElement[]>([])

  const t = useTranslate('interface', 'components.bottomBar.headerSettings.headerUsps')

  return (
    <>
      <div className="dali-settingslayer-element">{t('description')}</div>
      <IteratorField className="dali-settingslayer-element" name="headerUsps">
        {(item: ImmutableMap, idx: number) => {
          const disabled = !item.get('active')
          const isLinkEmpty = !item.get('link')

          return (
            <div
              className={cc([
                'ep-header-usps-settings',
                {
                  disabled,
                  'icon-hidden': !item.getIn(['icon', 'show']),
                },
              ])}
            >
              <div className="ep-header-usps-settings-button">
                <span className="icon-container body">
                  {/* "body" class so that the theme's icon styles apply */}
                  <span data-testid="header-usp-icon" className={`ep-${item.getIn(['icon', 'name'])}-icon`} />
                </span>
                <Popover
                  anchor={
                    <div className="ep-header-usps-settings-form">
                      <CheckboxField name="active" onInput={() => textFields.current[idx].focus()} />
                      <InputField name="text" disabled={disabled} ref={(node) => (textFields.current[idx] = node)} />
                    </div>
                  }
                  trigger={
                    <button className="ep-header-usps-settings-button-change" type="button" disabled={disabled}>
                      {t('configureUspButton.label')}
                    </button>
                  }
                  className="ep-icon-picker ep-header-usps-settings-icon-picker"
                  side="left"
                  align="end"
                  sideOffset={50}
                  alignOffset={0}
                  usePortal
                  avoidCollisions
                >
                  <FormValue name="icon">
                    {(icon: ImmutableMap, setIcon: (newIcon: ImmutableMap) => void) => (
                      <>
                        <IconPicker
                          icon={icon.get('name')}
                          setIcon={(name) => setIcon(Immutable.Map({ name, show: true }))}
                          className={cc([
                            {
                              'icon-hidden': !icon.get('show'),
                            },
                          ])}
                        />
                        <label className="ep-usp-icon-picker-switch-button">
                          <div className="ep-flip-switch">
                            <input
                              type="checkbox"
                              name="ep-flip-switch"
                              className="ep-flip-switch-checkbox"
                              id="hide-icon"
                              checked={!icon.get('show')}
                              onChange={(e) =>
                                setIcon(Immutable.Map({ name: icon.get('name'), show: !e.target.checked }))
                              }
                            />
                            <span className="ep-flip-switch-label" />
                          </div>
                          <span>{t('configureUspPopover.hideIconSwitch.label')}</span>
                        </label>
                      </>
                    )}
                  </FormValue>
                  <FormValue name="link">
                    {(link, setLink) => (
                      <LinkTooltipSettingsLayer
                        t={t}
                        link={link}
                        setLink={setLink}
                        label={'configureUspPopover.linkInputField.label'}
                      />
                    )}
                  </FormValue>
                  <FormGroup
                    className={cc([{ disabled: isLinkEmpty }, 'ep-form-row-no-margin'])}
                    name="openInNewTab"
                    tagName="label"
                    label={t('configureUspPopover.openLinkInNewTabCheckbox.label')}
                    labelAfterComponent
                  >
                    <CheckboxField name="openInNewTab" disabled={isLinkEmpty} />
                  </FormGroup>
                </Popover>
              </div>
            </div>
          )
        }}
      </IteratorField>
    </>
  )
}
HeaderUsps.defaultValue = Immutable.fromJS([
  { active: false, icon: { show: true, name: 'headphones' }, text: '', link: '', openInNewTab: false },
  { active: false, icon: { show: true, name: 'shipping' }, text: '', link: '', openInNewTab: false },
  { active: false, icon: { show: true, name: 'change' }, text: '', link: '', openInNewTab: false },
  { active: false, icon: { show: true, name: 'clock-24' }, text: '', link: '', openInNewTab: false },
  { active: false, icon: { show: true, name: 'gift' }, text: '', link: '', openInNewTab: false },
])
